import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUIIcon from '@mui/icons-material';

const Theme = Common.Theme;

export const ArrowDownIcon = styled(MUIIcon.KeyboardArrowDown)`
	color: ${Theme.green};
	position: relative;
	top: 2px;
`;

export const HomeIcon = styled(MUIIcon.Home)``;

export const InventoryIcon = styled(MUIIcon.Store)``;

export const OrdersIcon = styled(MUIIcon.ShoppingCart)``;

export const DSOPricingIcon = styled(MUIIcon.Business)``;

export const SettingsIcon = styled(MUIIcon.Settings)``;

export const LogoutIcon = styled(MUIIcon.ExitToApp)``;

export const LinkIcon = styled(MUIIcon.InsertLink)``;

